'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Actions = {
  'facebook': function facebook() {
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(document.URL) + '&t=' + encodeURIComponent(document.URL));
    return false;
  },
  'twitter': function twitter() {
    window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(document.title) + ':%20' + encodeURIComponent(document.URL));
    return false;
  },
  'google': function google() {
    window.open('https://plus.google.com/share?url=' + encodeURIComponent(document.URL));
    return false;
  },
  'pocket': function pocket() {
    window.open('https://getpocket.com/save?url=' + encodeURIComponent(document.URL) + '&title=' + encodeURIComponent(document.title));
    return false;
  },
  'linkedin': function linkedin() {
    window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(document.URL) + '&title=' + encodeURIComponent(document.title));
    return false;
  },
  'reddit': function reddit() {
    window.open('http://www.reddit.com/submit?url=' + encodeURIComponent(document.URL) + '&title=' + encodeURIComponent(document.title));
    return false;
  },
  'instagram': function instagram() {
    window.open('http://www.reddit.com/submit?url=' + encodeURIComponent(document.URL) + '&title=' + encodeURIComponent(document.title));
    return false;
  }
};

exports.default = Actions;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-social-share/dist/components/Actions.js
// module id = 57
// module chunks = 168707334958949